import { IUser } from "../components/AutoCompleteSearches/AutoCompleteSearches.types";
import { ISecurityRoleGroup } from "../components/AutoCompleteSearches/SecurityRoleGroupAutoSearch";
import { IOpportunities } from "../redux/opportunites/opportunites.types";
import { IRole } from "../redux/security/security.types";

type IRemoveDuplicateItems = ISecurityRoleGroup | IOpportunities | IUser;

export const removeDuplicateItems = (options: IRemoveDuplicateItems[], key: string) => {
	//@ts-ignore
	return [...new Map(options.map((item) => [item[key], item])).values()];
};

export const removeDuplicateUsers = (options: IUser[]) => {
	return options.filter(
		(item, index) =>
			options.find((item2) => item2.user_uuid === item.user_uuid)?.user_uuid !==
			item.user_uuid
	);
};
